import { Button, Modal } from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../utils/AppFunction";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../appContext/AppContext";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useIntl } from "react-intl";
import GenerateFormComponent from "../../component/generate-form/GenerateFormHTMLNoValidV2";
import { updateDanhMuc, addDanhMuc } from "../DanhMucServices";
import { CODE } from "../../utils/Constant";
import { toast } from "react-toastify";
import { IconBack, IconButtonSave } from "../../component/IconSvg";

interface Props {
  show?: boolean;
  listJsonGenerate?: any;
  onHide: () => void;
  initialValues?: any;
  warehouseId?: any;
  type?: any;
  dataEdit?: any;
  item?: any;
}

const DialogThemDanhMuc = (props: Props) => {
  const {
    show,
    onHide,
    item,
    dataEdit,
    warehouseId,
    listJsonGenerate,
    initialValues = {
      code: "",
      name: "",
      taxCode: "",
    },
    type,
  } = props;
  const { setIsLoading } = useContext(AppContext);
  const intl = useIntl();
  const [isView, setIsView] = useState<boolean>();
  // const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [dataVatTu, setDataVatTu] = useState<any>({});
  const [customFieldReadOnly, setCustomFieldReadOnly] = useState<any>();

  const handleSaveDM = async (values: any) => {
    const dataSubmit = {
      ...values,
    };
    try {
      setIsLoading(true);
      const id = values[item?.code]?.termModelId;
      const { data } = id
        ? await updateDanhMuc(listJsonGenerate?.path, dataSubmit[item?.code])
        : await addDanhMuc(listJsonGenerate?.path, dataSubmit[item?.code]);
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        setIsLoading(false);
        toast.success((id ? "Cập nhật" : "Thêm") + ` ${item?.name} thành công`);
        onHide();
      } else {
        let errorMesage =
          data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    }
  };

  // useEffect(() => {
  //   updateForm();
  // }, []);

  useEffect(() => {
    setCustomFieldReadOnly({
      codeExport: isView,
      reason: isView,
      notes: isView,
    });
  }, []);


  const onFieldPropsChange = (data: any) => {
    // if (data.currentInput === "code" && data.value === "") {
    //   setCustomFieldReadOnly((prev: any) => ({ ...prev, notes: true }));
    // } else {
    //   setCustomFieldReadOnly((prev: any) => ({ ...prev, notes: false }));
    // }
  };
  return (
    <Modal centered show={show} onHide={onHide} size="lg" className=" spaces ">
      <Formik
        enableReinitialize
        // initialValues={{ [item?.code]: initialValues }}
        initialValues={generateInitValues(listJsonGenerate, item.code)}
        validationSchema={generateValidationSchema(listJsonGenerate, item.code)}
        onSubmit={handleSaveDM}
      >
        {({
          values,
          touched,
          errors,
          setValues,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className="">
              <Modal.Header className="header-modal min-h-40px">
                <div className="d-flex gap-6">
                  <div
                    className="d-flex align-items-center title-back gap-3 cursor-pointer"
                    onClick={onHide}
                  >
                    <IconBack />
                    <span className="fw-500 ps-2">Quay lại</span>
                  </div>
                </div>
              </Modal.Header>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <GenerateFormComponent
                    // customFieldReadOnly={customFieldReadOnly}
                    listFieldAuto={listJsonGenerate}
                    itemEdit={dataEdit}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    setFieldValue={setFieldValue}
                    onFieldPropsChange={onFieldPropsChange}
                    modelID={item?.code}
                  />
                </div>

                <div className=" d-flex w-100 spaces py-6 pl-5 mt-10">
                  <Button
                    type="submit"
                    className="btn btn-fill min-w-120px spaces ml-5"
                  >
                    <IconButtonSave /> Lưu
                  </Button>
                </div>
              </Modal.Body>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogThemDanhMuc;
